export default __webpack_public_path__ + "static/Poppins-SemiBold-5981b450a68d5134225b3eb6b04d523f.ttf";